import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ClientsStore from '../../stores/ClientsStore'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Button, Confirm, Dimmer, Grid, GridColumn, Loader } from 'semantic-ui-react'
import ClientPrincipalInformation from '../../components/Clients/ClientPrincipalInformation'
import AddressInformation from '../../components/Clients/AddressInformation'
import Toast from '../../components/Toast'
import ModalUnsavedConfirmation from '../../components/ModalUnsavedConfirmation'
import LoadingWrapper from '../../components/LoadingWrapper'
import ModalError from '../../components/ModalError'
import AddressInspection from '../../components/Clients/AddressInspection'
import AuthenticationStore from '../../stores/AuthenticationStore'

@inject('clientsStore')
@withRouter
@observer
class ClientsViewScreen extends Component {
  static propTypes = {
    authenticationStore: PropTypes.instanceOf(AuthenticationStore),
    clientsStore: PropTypes.instanceOf(ClientsStore),
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object
  }

  state = {
    saveConfirm: false,
    editMode: false
  }

  /** @type {Client} */
  client = null
  canEdit = false

  constructor (props) {
    super(props)
    if (!props.match.params.clientId) {
      props.history.goBack()
    }
    window.document.title = ''
    const role = props.authenticationStore.getRoleForControllerAction('clients', 'edit')
    this.canEdit = role === 'edit'
  }

  componentDidMount () {
    const { clientsStore, match, location } = this.props
    clientsStore.loadOne(match.params.clientId).then(() => {
      if (clientsStore.client) {
        window.document.title = clientsStore.client.name
      }
      if (location.hash) {
        document.getElementById(location.hash.replace('#', '')).scrollIntoView({ behavior: 'smooth' })
      }
    }).catch(e => {
      console.log(e)
    })
  }

  handleSaveClient = () => {
    const { clientsStore } = this.props
    this.setState({ saveConfirm: false })
    clientsStore.save().then(() => {
      window.scrollTo(0, 0)
      this.setState({ editMode: false })
    })
  }

  handleRevertClient = () => {
    const { clientsStore } = this.props
    clientsStore.revert()
    this.setState({ editMode: false })
  }

  activateEdit = () => {
    if (!this.canEdit) {
      return
    }
    this.setState({ editMode: true })
  }

  render () {
    const { clientsStore } = this.props
    const { isLoading, isSaving, client, isDirty, toasts } = clientsStore
    const { editMode, saveConfirm } = this.state

    if (isLoading) {
      return (
        <Dimmer page active={isLoading}>
          <Loader />
        </Dimmer>
      )
    }
    return (
      <>
        {(this.canEdit && editMode) && <ModalUnsavedConfirmation
          when={isDirty}
          onSave={this.handleSaveClient}
          onDiscard={this.handleRevertClient}
                                       />}
        <LoadingWrapper loading={isSaving} message='Sauvegarde en cours...' />
        <ModalError store={clientsStore} />
        <Toast toasts={toasts} />
        <ClientPrincipalInformation
          clientsStore={clientsStore} canEdit={(this.canEdit && editMode)}
          editMode={editMode}
          canSendEmailLogin={this.canEdit}
          activateEdit={this.canEdit ? this.activateEdit : null}
        />
        <AddressInformation clientsStore={clientsStore} canEdit={(this.canEdit && editMode)} />
        {(this.canEdit && editMode) &&
          <Grid columns='equal'>
            <GridColumn>
              <Confirm
                open={saveConfirm}
                content='Êtes-vous sûr de vouloir sauvegarder les modifications du client?'
                confirmButton='Oui'
                cancelButton='Non'
                onCancel={() => { this.setState({ saveConfirm: false }) }}
                onConfirm={this.handleSaveClient}
              />
              <Button
                disabled={!client.isDirty}
                content='Enregistrer'
                primary
                onClick={() => { this.setState({ saveConfirm: true }) }}
              />
            </GridColumn>
            <GridColumn textAlign='right'>
              <Button
                content='Annuler'
                onClick={this.handleRevertClient}
              />
            </GridColumn>
          </Grid>}
        <AddressInspection clientsStore={clientsStore} canEdit={this.canEdit} />
      </>
    )
  }
}

export default ClientsViewScreen
